/**
 * @module com.inq.flash.client.control.messagehandlers
 * @constructor
 */

com.inq.flash.client.control.messagehandlers.ChatWebCallMessageHandler = function () {
	com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.call(this, com.inq.flash.client.data.MessageFields.TYPE_CHAT_WEBCALL);
};
$hxClasses.extend(com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler, com.inq.flash.client.control.messagehandlers.ChatWebCallMessageHandler,
	"com.inq.flash.client.control.messagehandlers.ChatWebCallMessageHandler");

com.inq.flash.client.control.messagehandlers.ChatWebCallMessageHandler.prototype.processMessage = function(message) {
	com.inq.flash.client.control.WebRTCMgr.processAgentMessage(message.getProperty(com.inq.flash.client.data.MessageFields.KEY_WEBCALL_ACTION));
};